export const INTAKE_EXPIRY_MESSAGES = {
    IntakeCompleted: {
        title: 'Intake Completed',
        message: 'Intake is already completed!',
    },
    Expired: {
        title: 'Intake Expired',
        message: 'The intake form has not been completed before its expiry date.',
    },
    Terminated: {
        title: 'Terminated',
        message:
            'The intake link has been expired. Please contact your law firm for more info or an updated link.',
    },
    NewManualQuoteSent: {
        title: 'New Manual Quote Sent',
        message:
            'A new version of the quote has been sent to you and this quote is no longer valid. Please contact us if you have questions',
    },
    Forbidden: {
        title: 'Intake Completed',
        message: 'Intake is already completed!',
    },
    Restarted: {
        title: 'New Link Sent',
        message:
            'This form link has expired. A new link has been sent to your email. Please check your inbox.',
    },
} as const;

const ADDITIONAL_BLOCKING_INTAKE_STATUSES = ['Failed', 'NoSuchInstanceFound'] as const;

/** Statuses that should show the blocking status screen instead of the intake form. */
export function isBlockingIntakeStatus(status: string | null | undefined): boolean {
    if (!status) return false;
    return (
        status in INTAKE_EXPIRY_MESSAGES ||
        ADDITIONAL_BLOCKING_INTAKE_STATUSES.includes(
            status as (typeof ADDITIONAL_BLOCKING_INTAKE_STATUSES)[number],
        )
    );
}
